import { getCharterBySlug } from './charterData';
import CharterDetailTemplate from './CharterDetailTemplate';

const SanClementePage = () => {
  const data = getCharterBySlug('san-clemente-island');
  if (!data) return null;
  return <CharterDetailTemplate destination={data} />;
};

export default SanClementePage;
